/** AI 文案模板：平台选项 + 违禁词手输解析（FE-01） */

import { PLATFORM_OPTIONS } from '@/utils/platformShopCatalog';

/**
 * 平台选项与「店铺管理」下拉同源（PLATFORM_OPTIONS）。
 * 值统一取小写平台码，和后端 white-list（shein/temu/tiktok/amazon）对齐。
 */
export const COPYWRITING_TEMPLATE_PLATFORM_OPTIONS = PLATFORM_OPTIONS.map((opt) => ({
  value: String(opt.value || '').trim().toLowerCase(),
  label: opt.label,
})).filter((opt) => opt.value);

export const DEFAULT_COPYWRITING_TEMPLATE_PLATFORM =
  COPYWRITING_TEMPLATE_PLATFORM_OPTIONS[0]?.value || 'shein';

/**
 * 手输违禁词 → string[]
 * 支持中英文逗号、顿号、换行；空串 → []
 */
export function parseForbiddenWordsInput(text) {
  const raw = String(text ?? '').trim();
  if (!raw) return [];
  return raw
    .split(/[,，、\r\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);
}

/** string[] → 表单可读文本（中文逗号拼接）；空数组 → '' */
export function serializeForbiddenWords(words) {
  if (!Array.isArray(words) || words.length === 0) return '';
  return words
    .map((w) => String(w ?? '').trim())
    .filter(Boolean)
    .join('，');
}

export function getCopywritingTemplatePlatformLabel(value) {
  const code = String(value || '').trim().toLowerCase();
  const found = COPYWRITING_TEMPLATE_PLATFORM_OPTIONS.find((o) => o.value === code);
  return found?.label || (code ? String(value).toUpperCase() : '');
}
